import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';

const JadePage = () => {
  return <ComingSoon title="J.A.D.E" subtitle="Our Products" />;
};

export const Route = createFileRoute('/$locale/products/jade')({
  component: JadePage,
});
